import type { AxiosInstance } from "axios";

export const collectPrivacyPolicyConsent = (client: AxiosInstance, customerSlug: string) =>
  client.post(`/api/${customerSlug}/consents/collect`, {
    privacy_policy: "granted",
  });
